import { isObject, type Material, useApiMaterialsV1MaterialsList } from 'api';
import { useState } from 'react';

import type { WithRequired } from '../../utils/types';
import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type MaterialWithName = WithRequired<Material, 'name'>;
const isMaterialWithName = (material: Material): material is WithRequired<Material, 'name'> =>
  material.name !== undefined && material.name.length > 0;

export type MaterialAutocompleteProps = Omit<AutocompleteFieldProps<MaterialWithName>, 'options' | 'defaultValue'> & {
  defaultValue?: MaterialWithName['id'];
};

export const MaterialAutocomplete = ({ defaultValue, ...props }: MaterialAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiMaterialsV1MaterialsList({
    search: query,
  });

  // TODO: move filtering to backend https://linear.app/safi/issue/TRADE-3478/materialsv1materials-returns-valid-materials
  const validOptions = (data?.results || []).filter(isMaterialWithName);

  return (
    <AutocompleteField<MaterialWithName>
      data-testid="material-autocomplete"
      getOptionLabel={(item) => {
        if (isObject(item) && item?.name) {
          return item.name;
        }
        return '';
      }}
      loading={isLoading}
      groupBy={(option) => option.material_type_name}
      options={validOptions}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      {...props}
    />
  );
};
